const branchName = (pathname) => {
  if (pathname.startsWith('/')) pathname = pathname.substring(1);
  if (pathname.endsWith('/')) pathname = pathname.substring(0, pathname.length - 1);
  return pathname;
};

const instructions = document.getElementById('instructions');
const hidden = document.getElementById('hidden');
document.getElementById('branch-name').innerText = branchName(window.location.pathname);

const hideInstructions = () => {
  hidden.style.display = 'inline';
  instructions.style.display = 'none';
};

const showInstructions = () => {
  hidden.style.display = 'none';
  instructions.style.display = 'inline';
};

const setup = async () => {
  document.querySelectorAll('code').forEach((e) => {
    e.onclick = () => navigator.clipboard.writeText(e.innerText);
  });

  if (document.getElementById('close')) {
    document.getElementById('close').onclick = hideInstructions;
    document.getElementById('open').onclick = showInstructions;
  }
};

setup();
